module.exports = __webpack_public_path__ + "static/media/Strudel-BitcoinCash-Icon.8bd621a4.png";